const ScheduleCell = ({
  children,
  className,
  noMinWidth = false,
  noFirstSticky = false,
  widthRem = null,
}) => {
  // first:z-10 keeps the sticky-left "Crews" column above the day cells
  // when the grid scrolls horizontally. Without it, day cells (later in
  // source order with default z-index) render on top of the sticky
  // column — visible bug in the multi-grid Optimizer (#105) when a grid
  // is narrow and the user scrolls the body cells horizontally.
  //
  // min-w reduced from 8.6rem to 7rem (#105 follow-up) so single-grid
  // mode fits on standard ~1280-1366px viewports without horizontal
  // scrolling. Multi-grid still scrolls within each narrow grid when
  // needed; min-width prevents cells from collapsing to unusable sizes.
  //
  // noMinWidth=true removes the min-width entirely — used by single-grid
  // OptimizerGrid so cells can shrink below 7rem when the user widens
  // the RTS sidebar enough that the natural row width would otherwise
  // overflow. Multi-grid keeps min-width so cells remain readable.
  //
  // noFirstSticky=true opts out of the `first:` modifier set. Used by
  // the Time Machine #114 Phase 6 right grid where the Crews column
  // is omitted (LEFT grid's column serves both); without this opt-out
  // the first date column becomes sticky-left and stops scrolling.
  //
  // widthRem (Phase 6 Diff Pair): when set, forces a FIXED column width
  // via inline style. Drops `flex-1`, `basis-32`, and `min-w-28` so
  // the cell neither grows nor shrinks with container width or data
  // content. Lets the row overflow the container horizontally — the
  // user scrolls to see all days at a consistent column width matching
  // single-grid Optimizer's "normal" column feel.
  const isFixedWidth = typeof widthRem === "number";
  const flexClasses = isFixedWidth
    ? "overflow-hidden ml-4"
    : `${noMinWidth ? "" : "min-w-28"} flex-1 overflow-hidden basis-32 ml-4`;
  const fixedStyle = isFixedWidth
    ? { width: `${widthRem}rem`, flex: "none" }
    : undefined;
  return (
    <div
      className={`${className} ${flexClasses} ${
        noFirstSticky
          ? ""
          : "first:ml-0 first:sticky first:left-0 first:z-10"
      }`}
      style={fixedStyle}
    >
      {children}
    </div>
  );
};

export default ScheduleCell;
